import { ApolloCache } from '@apollo/client';
import { FWorldMapMarker } from 'graphql/fragment/__generated__/FWorldMapMarker';
import { WORLD_MAP_MARKER_FRAGMENT } from 'graphql/fragment/worldFragment';
import { AddToWorldMapSet_addToWorldMapSet } from 'graphql/mutation/__generated__/AddToWorldMapSet';
import { WorldMapMarker_worldMapMarker } from 'graphql/query/__generated__/WorldMapMarker';
import { PartialDeep } from 'type-fest';

const existsWorldMapMarkerFragment = (cache: ApolloCache<unknown>, worldMapMarkerId: string) => {
    const fragment = cache.readFragment({
        id: cache.identify({
            __typename: 'WorldMapMarker',
            worldMapMarkerId
        }),
        fragment: WORLD_MAP_MARKER_FRAGMENT
    });

    return !!fragment;
};

export const cacheAddMarker = (
    cache: ApolloCache<unknown>,
    worldMapId: string,
    data: WorldMapMarker_worldMapMarker
) => {
    cache.modify({
        id: cache.identify({
            __typename: 'WorldMap',
            worldMapId: worldMapId
        }),
        fields: {
            markers: (existing): PartialDeep<WorldMapMarker_worldMapMarker>[] => {
                const exists = existing.some((e) => e.worldMapMarkerId === data.worldMapMarkerId);
                if (exists) {
                    return existing;
                }
                return [...existing, data];
            }
        }
    });
};

export const cacheAddMarkerToWorldMapSet = (
    cache: ApolloCache<unknown>,
    worldMapMarkerId: string,
    data: AddToWorldMapSet_addToWorldMapSet
) => {
    if (!existsWorldMapMarkerFragment(cache, worldMapMarkerId)) {
        return;
    }

    cache.updateFragment<FWorldMapMarker>(
        {
            id: cache.identify({
                __typename: 'WorldMapMarker',
                worldMapMarkerId
            }),
            fragment: WORLD_MAP_MARKER_FRAGMENT
        },
        (oldData) => {
            const exists = oldData.worldMapSets.some((e) => e.worldMapSetId === data.worldMapSetId);
            if (exists) {
                return;
            }
            return {
                ...oldData,
                worldMapSets: [...oldData.worldMapSets, data]
            };
        }
    );
};

export const cacheRemoveMarkerFromWorldMapSet = (
    cache: ApolloCache<unknown>,
    worldMapMarkerId: string,
    worldMapSetId: string
) => {
    if (!existsWorldMapMarkerFragment(cache, worldMapMarkerId)) {
        return;
    }

    cache.updateFragment<FWorldMapMarker>(
        {
            id: cache.identify({
                __typename: 'WorldMapMarker',
                worldMapMarkerId
            }),
            fragment: WORLD_MAP_MARKER_FRAGMENT
        },
        (oldData) => ({
            ...oldData,
            worldMapSets: oldData.worldMapSets.filter((e) => e.worldMapSetId !== worldMapSetId)
        })
    );
};
